import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import axios from 'axios';
import { bundle } from '../../helpers';
import { List } from 'immutable';
/**
 * @private
 * The default number of messages retrieved per page.
 */

export var DEFAULT_MESSAGE_LIMIT = 25;
/**
 * @private
 * The default number of discussions retrieved per page.
 */

export var DEFAULT_DISCUSSION_LIMIT = 10;

var isExistingAttachment = function isExistingAttachment(attachment) {
  return attachment.type === 'attachment';
};

var baseUrl = function baseUrl() {
  return "".concat(bundle.spaceLocation(), "/app/discussions");
};
/**
 * Send a message to a discussion.
 *
 * @param {object} params message parameters
 * @param {string} params.id the discussion id to send the message to.
 * @param {string} params.message message text to send.
 * @param {string} params.parentId the id of the parent message.
 * @param {array} params.attachment an array of File objects to attach.
 */


export var sendMessage = function sendMessage(params) {
  var message = _objectSpread({
    content: [{
      type: 'text',
      value: params.message
    }]
  }, params.parentId ? {
    parent: {
      id: params.parentId
    }
  } : {});

  if (params.attachment) {
    var formData = new FormData();
    formData.append('message', JSON.stringify(message));
    params.attachment.forEach(function (attachment) {
      formData.append('attachments', attachment);
    });
    axios.request({
      url: "".concat(baseUrl(), "/api/v1/discussions/").concat(params.id, "/messages"),
      method: 'post',
      headers: {
        'Content-Type': 'multipart/form-data'
      },
      data: formData
    });
  } else {
    return axios.request({
      url: "".concat(baseUrl(), "/api/v1/discussions/").concat(params.id, "/messages"),
      method: 'post',
      data: message
    });
  }
};
export var updateMessage = function updateMessage(params) {
  var attachments = params.attachment || [];
  var message = {
    content: [{
      type: 'text',
      value: params.message
    }].concat(_toConsumableArray(attachments.filter(isExistingAttachment)))
  };
  var newAttachments = attachments.filter(function (a) {
    return !isExistingAttachment(a);
  });
  var formData = new FormData();
  formData.append('message', JSON.stringify(message));
  newAttachments.forEach(function (attachment) {
    formData.append('attachments', attachment);
  });
  axios.request({
    url: "".concat(baseUrl(), "/api/v1/discussions/").concat(params.discussionId, "/messages/").concat(params.id),
    method: 'post',
    headers: {
      'Content-Type': 'multipart/form-data'
    },
    data: formData
  });
};
export var fetchMessages = function fetchMessages(id, pageToken) {
  return axios.request({
    url: "".concat(baseUrl(), "/api/v1/discussions/").concat(id, "/messages"),
    method: 'get',
    params: {
      pageToken: pageToken,
      limit: DEFAULT_MESSAGE_LIMIT
    }
  }).then(function (response) {
    return response.data;
  })["catch"](function (response) {
    return {
      error: response
    };
  });
};
export var fetchMessage = function fetchMessage(_ref) {
  var discussionId = _ref.discussionId,
      id = _ref.id;
  return axios.request({
    url: "".concat(baseUrl(), "/api/v1/discussions/").concat(discussionId, "/messages/").concat(id),
    method: 'get'
  }).then(function (response) {
    return response.data;
  })["catch"](function (response) {
    return {
      error: response
    };
  });
};
export var fetchMessageHistory = function fetchMessageHistory(_ref2) {
  var discussionId = _ref2.discussionId,
      id = _ref2.id;
  return axios.request({
    url: "".concat(baseUrl(), "/api/v1/discussions/").concat(discussionId, "/messages/").concat(id, "/versions"),
    method: 'get'
  }).then(function (response) {
    return response.data;
  })["catch"](function (response) {
    return {
      error: response
    };
  });
};
/**
 * Fetch a discussion by `id`.
 * @param {object} params fetch parameters
 * @param {string} params.id the discussion id
 */

export var fetchDiscussion = function fetchDiscussion(_ref3) {
  var id = _ref3.id;
  return axios.request({
    url: "".concat(baseUrl(), "/api/v1/discussions/").concat(id),
    method: 'get'
  }).then(function (response) {
    return response.data;
  })["catch"](function (response) {
    return {
      error: response
    };
  });
};
/**
 * Fetch discussions based upon parameters.
 *
 * @param {object} params fetch parameters
 * @param {string} params.pageToken next page token for paginated results
 * @param {object} params.relatedItem search for discussions based upon related item
 */

export var fetchDiscussions = function fetchDiscussions(_ref4) {
  var pageToken = _ref4.pageToken,
      title = _ref4.title,
      _ref4$relatedItem = _ref4.relatedItem,
      relatedItem = _ref4$relatedItem === void 0 ? {} : _ref4$relatedItem,
      isArchived = _ref4.isArchived,
      start = _ref4.start,
      end = _ref4.end;
  var type = relatedItem.type,
      key = relatedItem.key;
  return axios.get("".concat(baseUrl(), "/api/v1/discussions"), {
    params: {
      title: title && title.length > 0 ? title : null,
      limit: DEFAULT_DISCUSSION_LIMIT,
      type: type,
      key: key,
      pageToken: pageToken,
      archived: isArchived ? true : undefined,
      start: start,
      end: end
    }
  }).then(function (response) {
    return response.data;
  })["catch"](function (response) {
    return {
      error: response
    };
  });
};
export var createDiscussion = function createDiscussion(_ref5) {
  var title = _ref5.title,
      description = _ref5.description,
      _ref5$isPrivate = _ref5.isPrivate,
      isPrivate = _ref5$isPrivate === void 0 ? false : _ref5$isPrivate,
      owningUsers = _ref5.owningUsers,
      owningTeams = _ref5.owningTeams,
      joinPolicy = _ref5.joinPolicy;
  return axios.request({
    method: 'post',
    url: "".concat(baseUrl(), "/api/v1/discussions"),
    data: {
      title: title,
      description: description,
      isArchived: false,
      owningUsers: owningUsers,
      owningTeams: owningTeams,
      isPrivate: isPrivate,
      joinPolicy: joinPolicy
    }
  }).then(function (response) {
    return response.data;
  })["catch"](function (response) {
    return {
      error: response
    };
  });
};
export var updateDiscussion = function updateDiscussion(id, data) {
  return axios.request({
    method: 'put',
    url: "".concat(baseUrl(), "/api/v1/discussions/").concat(id),
    data: data
  }).then(function (response) {
    return response.data;
  })["catch"](function (response) {
    return {
      error: response
    };
  });
};
export var fetchInvites = function fetchInvites(id) {
  return axios.request({
    url: "".concat(baseUrl(), "/api/v1/discussions/").concat(id, "/invitations"),
    method: 'get'
  }).then(function (response) {
    return response.data;
  })["catch"](function (response) {
    return {
      error: response
    };
  });
};
export var createInvite = function createInvite(_ref6) {
  var discussionId = _ref6.discussionId,
      type = _ref6.type,
      value = _ref6.value,
      message = _ref6.message;
  return axios.request({
    url: "".concat(baseUrl(), "/api/v1/discussions/").concat(discussionId, "/invitations"),
    method: 'post',
    data: type === 'email' ? {
      email: value,
      message: message
    } : {
      user: {
        username: value
      },
      message: message
    }
  }).then(function (response) {
    return response.data;
  })["catch"](function (response) {
    return {
      error: response
    };
  });
};
export var resendInvite = function resendInvite(_ref7) {
  var discussionId = _ref7.discussionId,
      email = _ref7.email,
      username = _ref7.username;
  return axios.request({
    url: "".concat(baseUrl(), "/api/v1/discussions/").concat(discussionId, "/invitations/").concat(email || username),
    method: 'put',
    params: _objectSpread({}, email ? {
      email: ''
    } : {}),
    data: {}
  }).then(function (response) {
    return response.data;
  })["catch"](function (response) {
    return {
      error: response
    };
  });
};
export var removeInvite = function removeInvite(_ref8) {
  var discussionId = _ref8.discussionId,
      email = _ref8.email,
      username = _ref8.username;
  return axios.request({
    url: "".concat(baseUrl(), "/api/v1/discussions/").concat(discussionId, "/invitations/").concat(email || username),
    method: 'delete',
    params: _objectSpread({}, email ? {
      email: ''
    } : {})
  }).then(function (response) {
    return response.data;
  })["catch"](function (response) {
    return {
      error: response
    };
  });
};
export var fetchParticipants = function fetchParticipants(id) {
  return axios.request({
    url: "".concat(baseUrl(), "/api/v1/discussions/").concat(id, "/participants"),
    method: 'get'
  }).then(function (response) {
    return response.data;
  })["catch"](function (response) {
    return {
      error: response
    };
  });
};
export var removeParticipant = function removeParticipant(id, username) {
  return axios.request({
    url: "".concat(baseUrl(), "/api/v1/discussions/").concat(id, "/participants/").concat(username),
    method: 'delete'
  }).then(function (response) {
    return response.data;
  })["catch"](function (response) {
    return {
      error: response
    };
  });
};
export var updateParticipant = function updateParticipant(id, username, data) {
  return axios.request({
    url: "".concat(baseUrl(), "/api/v1/discussions/").concat(id, "/participants/").concat(username),
    method: 'put',
    data: data
  }).then(function (response) {
    return response.data;
  })["catch"](function (response) {
    return {
      error: response
    };
  });
};
export var createRelatedItem = function createRelatedItem(id, relatedItem) {
  return axios.request({
    url: "".concat(baseUrl(), "/api/v1/discussions/").concat(id, "/relatedItems"),
    method: 'post',
    data: relatedItem
  }).then(function (response) {
    return response.data;
  })["catch"](function (response) {
    return {
      error: response
    };
  });
};
export var sendInvites = function sendInvites(discussion, values) {
  var participants = discussion.participants || List();
  var invitations = discussion.invitations || List();
  var existingUsernames = participants.concat(invitations).filter(function (involvement) {
    return involvement.user;
  }).map(function (involvement) {
    return involvement.user.username;
  });
  var existingEmails = invitations.map(function (invitation) {
    return invitation.email;
  });
  return Promise.all(values.get('invitees').map(function (item) {
    return {
      discussionId: discussion.id,
      type: item.get('username') ? 'username' : 'email',
      value: item.get('username') ? item.get('username') : item.get('email'),
      message: values.get('message')
    };
  }).filter(function (args) {
    return args.type === 'username' ? !existingUsernames.contains(args.value) : !existingEmails.contains(args.value);
  }).map(createInvite));
};
export var fetchDiscussionsVersion = function fetchDiscussionsVersion() {
  return axios.request({
    url: "".concat(baseUrl(), "/api/v1/version"),
    method: 'get'
  }).then(function (response) {
    return response.data;
  })["catch"](function (response) {
    return {
      error: response
    };
  });
};